import { useOrgContext } from '@/org/contexts/OrgContext'
import { CircleFragment } from '@gql'
import { useMemo } from 'react'
import { getVacantRoles } from '../vacantRoles'

// Roles nobody fills in the current org (see getVacantRoles)
export default function useVacantRoles(): CircleFragment[] {
  const { orgData } = useOrgContext()

  return useMemo(
    () =>
      orgData
        ? getVacantRoles(orgData.circles, (id) => orgData.membersOf(id))
        : [],
    [orgData]
  )
}
